import { Loader2 } from "lucide-react";
import { Button } from "../../../../components/tailwind/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../components/tailwind/dialog";
import { waBtn } from "../../utils/whatsappUiTokens";

export function WorkflowUnsavedChangesDialog({
  open,
  onOpenChange,
  isSaving,
  onSave,
  onDontSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" onPointerDownOutside={(event) => event.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Unsaved workflow changes</DialogTitle>
          <DialogDescription>
            You have changes that are not saved yet. Save your draft before leaving, or discard your edits.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button type="button" variant="outline" onClick={onDontSave} disabled={isSaving}>
            Don&apos;t save
          </Button>
          <Button
            type="button"
            className={waBtn.primary}
            onClick={onSave}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Saving…
              </>
            ) : (
              "Save"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
